import { render, staticRenderFns } from "./ActiveFilter.vue?vue&type=template&id=923da65e&scoped=true&"
import script from "./ActiveFilter.vue?vue&type=script&setup=true&lang=js&"
export * from "./ActiveFilter.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./ActiveFilter.vue?vue&type=style&index=0&id=923da65e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "923da65e",
  null
  
)

export default component.exports